import React from "react";
import PageContents from "../components/layouts/PageContents";
import HubspotForm from "react-hubspot-form";

const SurveyPage: React.FC = () => {
    return (
        <PageContents
            title="Survey"
            subtitle=""
            isForbidden={false}
            variant="small"
            maxWidth="lg"
        >
            <HubspotForm
                portalId="334027"
                formId="1aa9f623-4111-43ce-aad2-ddf1a1a61da2"
                loading={<div>Loading...</div>}
            />
        </PageContents>
    );
};

export default SurveyPage;
